import React from 'react';
import style from './Button.module.css';
import { cl } from 'lincd/utils/ClassNames';
import { useButton } from '@mui/base';
export const Button = React.forwardRef(function CustomButton(props, ref) {
    // props = useStyles(props, style.ButtonRoot);
    const { children, disabled, variant = 'filled', color = 'primary', fullWidth = false, startIcon, endIcon, } = props;
    const { active, focusVisible, getRootProps } = useButton({
        ...props,
        rootRef: ref,
    });
    return (React.createElement("button", { ...getRootProps(), className: cl(props.className, style.ButtonRoot, style[variant], color && style[color], disabled && style['disabled'], active && style['active'], focusVisible && style['focusVisible'], fullWidth && style['fullwidth']) },
        startIcon && startIcon,
        children,
        endIcon && endIcon));
});
//# sourceMappingURL=Button.js.map